import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// CSRF: the backend issues a `compliche_csrf` cookie (NOT httpOnly so JS can
// read it). On every state-changing request we echo it back via the
// X-CSRF-Token header. The first request after a fresh session won't have the
// cookie yet — a tiny "preflight" GET to /api/health solves that.
function readCookie(name) {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&") + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

let csrfPrimed = false;
async function ensureCsrf() {
  if (csrfPrimed || readCookie("compliche_csrf")) { csrfPrimed = true; return; }
  try { await axios.get(`${BACKEND_URL}/api/health`, { withCredentials: true }); } catch {}
  csrfPrimed = true;
}

api.interceptors.request.use(async (config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    await ensureCsrf();
    const token = readCookie("compliche_csrf");
    if (token) config.headers["X-CSRF-Token"] = token;
  }
  return config;
});

// 402 (Payment Required) means a trial limit was hit. Dispatch a custom event
// so the global TrialLimitModal can render the friendly upgrade prompt.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 402) {
      const detail = error.response.data?.detail || {};
      if (typeof window !== "undefined" && detail.code === "trial_limit_reached") {
        window.dispatchEvent(new CustomEvent("compliche:trial-limit", { detail }));
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
